import { CssBaseline, Theme } from '@mui/material';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SizeMe } from '../../felles/useResizeObserver';
import { makeStyles } from 'tss-react/mui';
import LPAppBar from '../../app/components/LPAppBar';
import LPDrawer from '../../app/components/LPDrawer';
import ShiftHome from '../../app/components/ShiftHome';
import Utils from '../../felles/Utils';
import MenuItemTarget from '../../models/MenuItemTarget';
import UISize from '../../models/UISize';
import * as actions from '../../store/actions/index';
import { AppState } from '../../store/rootReducer';
import CriteriaExcelExportForm from './components/CriteriaExcelExportForm';
import CriteriaItemAdd from './components/CriteriaItemAdd';
import CriteriaItemDelete from './components/CriteriaItemDelete';
import CriteriaItemEdit from './components/CriteriaItemEdit';
import CriteriaItemList from './components/CriteriaItemList';
import { useStyles } from '../../assets/styles/DefaultPageStyle';

// The CriteriaItemPage component
export default function CriteriaItemPage(/*props*/) {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const screenSize: UISize = useSelector(state => (state as AppState).ui.screenSize);
  const open = screenSize.width > 0 && screenSize.width < 1200 ? false : true;
  const navigate = useNavigate();
  const n: MenuItemTarget = useSelector((state) => (state as AppState).menuItem.menuItemTarget);
  const criteriaItemEditState = useSelector((state) => (state as AppState).tallenesTale.criteriaItemEditState);
  const criteriaItemDeletionState = useSelector((state) => (state as AppState).tallenesTale.criteriaItemDeletionState);
  const criteriaItemRegistrationState = useSelector((state) => (state as AppState).tallenesTale.criteriaItemRegistrationState);
  const criteriaItemId = useSelector((state) => (state as AppState).tallenesTale.criteriaItemId);
  const excelImportState = useSelector((state) => (state as AppState).tallenesTale.excelImportState);

  //  Handle key press
  const handlePressedKey = (event) => {
    const { key } = event;
    if ((event.shiftKey && key === 'End') || key === 'F3') {
      dispatch(actions.menuItemSetTarget(new MenuItemTarget(n.rootItem, n.item !== '' ? n.item : n.rootItem, '', '', n.tilpasset, n.prodSynlig, n.kodeSynlig
        , n.labelSynlig, n.menuSynlig, n.hasChildren, n.title)));
      dispatch(actions.menuItemSetSelected([n.rootItem, n.item + n.rootItem]));
      navigate(Utils.HOMEPAGE_CONTEXT + '/menu');
    }
  }

  // Generate edit states
  const generateEditStates = () => {
    switch (true) {
      case (criteriaItemEditState === 0):
        return null;
      default:
        return <CriteriaItemEdit id={criteriaItemId} />;
    }
  }

  // Generate registration states
  const generateRegistrationStates = () => {
    switch (true) {
      case (criteriaItemRegistrationState === 0):
        return null;
      case (criteriaItemRegistrationState === 1):
        return <CriteriaItemAdd />;
      case (criteriaItemRegistrationState === 2):
        return <CriteriaItemAdd />;
      case (criteriaItemRegistrationState === 3):
        return <CriteriaItemAdd />;
      default:
        return null;
    }
  }

  // Generate excel import states
  const generateExcelImportStates = () => {
    switch (true) {
      case (excelImportState === 0):
        return null;
      case (excelImportState === 1):
        return <CriteriaExcelExportForm />;
      case (excelImportState === 2):
        return <CriteriaExcelExportForm />;
      case (excelImportState === 3):
        return <CriteriaExcelExportForm />;
      case (excelImportState === 4):
        return <CriteriaExcelExportForm />;
      default:
        return null;
    }
  }

  // Generate deletion states
  const generateDeletionStates = () => {
    switch (true) {
      case (criteriaItemDeletionState === 0):
        return null;
      default:
        return <CriteriaItemDelete />;
    }
  }

  // Get the state of the sandwich button
  const button: boolean = useSelector((state) => (state as AppState).ui.isSandwichButtonTurnedOn);

  // Render the component
  return (
    <div className={classes.root} tabIndex={0} onKeyDown={(e) => handlePressedKey(e)}>
      <ShiftHome />
      <CssBaseline />
      <LPDrawer />
      <main className={clsx(classes.content, { [classes.contentShift]: button ? true : open })}>
        <LPAppBar ismenuvisible={true} />
        <SizeMe>{({ size }) => <CriteriaItemList size={size} />}</SizeMe>
      </main>
      {generateEditStates()}
      {generateRegistrationStates()}
      {generateDeletionStates()}
      {generateExcelImportStates()}
    </div>
  );
}